export function downloadBase64File(
  base64Data: string,
  fileName: string,
  mimeType: string,
): void {
  const base64 = base64Data.startsWith('data:')
    ? base64Data.split(',')[1]
    : base64Data

  const byteCharacters = atob(base64)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024)
    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }
    byteArrays.push(new Uint8Array(byteNumbers))
  }

  const blob = new Blob(byteArrays, { type: mimeType })

  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = fileName

  link.click()
}

// export function CleanFileName(text: any) {
//   // let cleanedText = text.toLowerCase()
//   let cleanedText = text
//
//   cleanedText = cleanedText.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
//
//   cleanedText = cleanedText.replace(/[<>:"/\\|?*,\s;@#$%&()\[\]\{\}]/g, ' ')
//   cleanedText = cleanedText.replace(/--+/g, '-')
//   cleanedText = cleanedText.replace(/^-|-$/g, '')
//
//   return cleanedText
// }

export function CleanFileName(text: any) {
  let cleanedText = String(text)

  cleanedText = cleanedText.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  cleanedText = cleanedText.replace(/[<>:"/\\|?*,\s;@#$%&()\[\]\{\}.!+_=]/g, ' ')
  cleanedText = cleanedText.replace(/-+/g, ' ')
  cleanedText = cleanedText.replace(/^-|-$/g, '')

  return cleanedText
}

